<template>
  <div class="loc-warpper">
    <div class="progress" v-if="isShow">
      <span class="progressSpan">{{progress}}%</span>
      <div class="progressBox">
        <van-progress :percentage="progress" inactive :show-pivot="false"/>
      </div>
      <span class="progressLoading">加载资源中...</span>
    </div>
    <iframe
      src="http://unrealera.gugushuzi.com/test/testdemo1"
      width="100%"
      height="100%"
      frameborder="0"
      scrolling="auto"
    ></iframe>
  </div>
</template>

<script>
import { Progress } from "vant";

export default {
  components: {
    [Progress.name]: Progress
  },
  data() {
    return {
      progress: 0,
      isShow: true
    };
  },
  mounted() {
    this.$nextTick(() => {
      let iframe = document.querySelector("iframe");
      let that = this;
      this.timer1 = setInterval(() => {
        this.progress += 15;
        if (this.progress >= 69) {
          this.progress = 84;
        }
      }, 500);
      iframe.onload = function() {
        that.progress = 100;
        clearInterval(that.timer1);
        that.isShow = false;
      };
    });
  }
};
</script>

<style lang="less" scoped>
.loc-warpper {
  position: relative;
  width: 100%;
  height:100%;
  .progress {
    text-align: center;
    position: absolute;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    .progressBox {
      position: absolute;
      left: 10%;
      width: 80%;
      top: 50%;
    }
    span {
      display: inline-block;
      &.progressSpan {
        position: absolute;
        top: 54%;
        left: 45%;
        color: #333;
        font-size: 17px;
        font-weight: 400;
      }
      &.progressLoading {
        position: absolute;
        left: 50%;
        top: 46%;
        color: #333;
        font-size: 13px;
        transform: translateX(-50%);
      }
    }
  }
}
</style>